import { render, staticRenderFns } from "./FeedBack.vue?vue&type=template&id=17bb0cd6&scoped=true&"
import script from "./FeedBack.vue?vue&type=script&lang=js&"
export * from "./FeedBack.vue?vue&type=script&lang=js&"
import style0 from "./FeedBack.vue?vue&type=style&index=0&id=17bb0cd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17bb0cd6",
  null
  
)

export default component.exports